/**
 * Tracks in-flight HTTP requests (apiClient) so forms can unlock after submit.
 */
let inflight = 0;
const listeners = new Set();

const emit = () => {
  listeners.forEach((fn) => {
    try {
      fn(inflight);
    } catch {
      // ignore listener errors
    }
  });
};

export const getHttpInflightCount = () => inflight;

export const onHttpInflightChange = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const trackHttpRequestStart = () => {
  inflight += 1;
  emit();
};

export const trackHttpRequestEnd = () => {
  inflight = Math.max(0, inflight - 1);
  emit();
};
